import Vue from 'vue'
import VueRouter from 'vue-router'
import Welcome from '../views/Welcome.vue'
import Feed from '@/components/Feed-RSS/Feed.vue'
import Post from '@/components/Feed-RSS/Post.vue'
import Friends from '@/components/User/Friends.vue'
import Profile from '@/components/User/Profile.vue'
import Signin from '@/components/User/Signin.vue'
import Signup from '@/components/User/Signup.vue'
import ProfileView from '@/components/User/ViewFriend.vue'
import Messages from '@/components/User/DirectM.vue'
import FindPeople from '@/components/User/FindUsers.vue'
import PostView from '@/components/User/PostView.vue'
import Invites from '@/components/User/Invites.vue'
import GroupChat from '@/components/User/GroupChat.vue'
import GroupChatInvite from '@/components/User/GroupChatInvite.vue'
import CreateGroupChat from '@/components/User/CreateGroupChat.vue'
import About from '@/views/About.vue'
import AuthGuard from './auth-guard'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/feed',
    name: 'Feed',
    component: Feed,
    beforeEnter:AuthGuard
  },
  {
    path: '/createapost',
    name: 'Post',
    component: Post,
    beforeEnter:AuthGuard
  },
  {
    path: '/friends',
    name: 'Friends',
    component: Friends,
    beforeEnter:AuthGuard
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    beforeEnter:AuthGuard
  },
  {
    path: '/profile/:id',
    name: 'Profile View',
    props: true,
    component: ProfileView,
    beforeEnter:AuthGuard
  },
  {
    path: '/messages/:id',
    name: 'Messages',
    props: true,
    component: Messages,
    beforeEnter:AuthGuard
  },
  {
    path: '/create/group-chat',
    name: 'Create Group Chat',
    component: CreateGroupChat,
    beforeEnter:AuthGuard
  },
  {
    path: '/group-chat/:id',
    name: 'Group Chats',
    props: true,
    component: GroupChat,
    beforeEnter:AuthGuard
  },
  {
    path: '/group-chat/invite/:id',
    name: 'Group Chat Invite',
    props: true,
    component: GroupChatInvite,
    beforeEnter:AuthGuard
  },
  {
    path:'/feed/:id',
    name: 'Post View',
    props: true,
    component: PostView,
    beforeEnter: AuthGuard
  },
  {
    path: '/findPeople',
    name: 'Find People',
    component: FindPeople,
    beforeEnter:AuthGuard
  },
  {
    path: '/invites',
    name: 'Invites',
    component: Invites,
    beforeEnter:AuthGuard
  },
  {
    path: '/signin',
    name: 'Sign In',
    component: Signin
  },
  {
    path: '/signup',
    name: 'Sign Up',
    component: Signup
  }

]

const router = new VueRouter({
  routes,
  mode:'history'
})

export default router
